import classnames from 'classnames';
import type { FunctionComponent } from 'react';
import type React from 'react';

import {
  Carousel,
  type CarouselProps,
} from '@/core/tamagoshi/Carousel/Carousel';

import styles from './ListingLayoutCarousel.module.scss';

interface Props extends CarouselProps, React.PropsWithChildren {
  className?: string;
}

export const childrenClassName = styles.children;

export const ListingLayoutCarousel: FunctionComponent<Props> = ({
  children,
  className,
  sliderClassName,
  titleClassName,
  controlsClassName,
  ...others
}) => {
  const rootClassnames = classnames(styles.root, className);
  const sliderClassnames = classnames(styles.slider, sliderClassName);
  const titleClassnames = classnames(styles.title, titleClassName);
  const controlsClassnames = classnames(styles.controls, controlsClassName);

  return (
    <Carousel
      className={rootClassnames}
      sliderClassName={sliderClassnames}
      titleClassName={titleClassnames}
      controlsClassName={controlsClassnames}
      {...others}
    >
      {children}
    </Carousel>
  );
};

ListingLayoutCarousel.displayName = 'ListingLayoutCarousel';
